// unallocatedAccess.js — who may use the Unallocated Receipts queue.
//
// Default rule: the queue is a MULTI-COMPANY screen. For a user who manages
// only one company it is hidden — there is nothing to cross-allocate, so the
// sidebar item and the route (SingleCompanyGuard) both stay out of the way.
//
// Escape hatch: an explicit per-user override in Manage Users → Module
// Permissions (`permissions.unallocated_receipts.view = true`) re-enables the
// page for that user even with a single company. The same predicate gates the
// "Transfer to Unallocated" row actions on Petty Cash / Company Expenses —
// never offer a move to a destination the user cannot open.
//
// Note: presence of the key alone is NOT enough — an explicit OFF
// (`{ view: false }`) must keep hiding it.

export function hasUnallocatedOverride(userProfile) {
  return userProfile?.permissions?.unallocated_receipts?.view === true;
}

export function isUnallocatedAllowedForCompanyCount(userProfile, companyCount) {
  return (companyCount || 0) > 1 || hasUnallocatedOverride(userProfile);
}
